import React from "react";
import AdminLayout from "../../../components/Layout/AdminLayout";
import ConfigSettings from './ConfigSettings';
import messages from '../../../locale/jsonMessages';



export default async function action({ store, intl }) {
    const title = intl?.formatMessage(messages.manageSiteConfig);
    let adminId, isAdminAuthenticated, isSuperAdmin;
    isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    isSuperAdmin = store?.getState()?.runtime?.isSuperAdmin;
    adminId = store?.getState()?.account?.privileges?.id
    const isDemoRestricted = store?.getState()?.siteSettings?.data?.isDemoRestricted;

    if (!isAdminAuthenticated || !isSuperAdmin) {
        return { redirect: '/siteadmin/login' };
    }
    return {
        title,
        component: <AdminLayout><ConfigSettings title={title} adminId={adminId} isDemoRestricted={isDemoRestricted} /></AdminLayout>
    }
}
